import { NgModule, Component } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule }   from '@angular/forms';
import { ImagesModule } from 'angular-shared-features/feature/custom-image/module/image-module';
import { SharedComponentsModule } from 'angular-shared-features/feature/shared-component/module/shared-component.module';
import { SharedDirectivesModule } from 'angular-shared-features/feature/shared-directives/module/shared.directives.module';
import { SharedPipesModule } from 'angular-shared-features/feature/shared-pipe/module/shared.pipes.module';
import { VgCoreModule } from "videogular2/core";
import { VgControlsModule } from "videogular2/controls";
import { VgOverlayPlayModule } from "videogular2/overlay-play";
import { VgBufferingModule } from "videogular2/buffering";
import { VgStreamingModule } from "videogular2/streaming";
//import { SwiperModule } from 'angular-shared-features/feature/swiper/module/swiper.module';
import { ClipboardModule } from 'ngx-clipboard';
import { CategoryFilter } from './search/category-filter/category-filter.component';
import { Rows } from './rows/rows.component';
import { PageTitle } from './pagetitle/pagetitle.component';
import { Row } from './row/row.component';
import { TitleRow } from './row/title-row/title-row.component';
import { ImageItem } from './image-item/image-item.component';
import { NavBar, NavPoint, NavMenu } from './navbar/';
import { MediaCell, MediaDetail, MediaHeadliner } from './media-cell/';
import { UserProfile } from './user-profile/user-profile.component'
import { VideoDetail } from './video-detail/video-detail.component';
import { PercentPlayed } from './percent-played/percent-played.component';
import { RowContainer } from './row-container/row-container.component';
import { MobileRowContainer } from './row-container/mobile/mobile-row-container.component';
import { MobileContentNavigation } from './mobile-navigation/mobile-content-navigation.component';
import { RowHeader } from './row-header/row-header.component';
import { SeasonHeader } from './season-header/season-header.component';
import { MarqueeRow, MarqueeCell, MarqueeList, SplitMarquee, FullMarquee } from './marquee/';
import { VideoRow } from './video-row/video-row.component';
import { GalleryCell, GalleryRow } from './gallery';
import { CopyRow, Copy } from './copy-row';
import { ContentRow } from './content-list/content/content.component';
import { ContentBuilder } from './content-builder/content-builder.component';
import { SocialIcons } from './social-icons/social-icons.component';
import { DetailRow } from './detail-row/detail-row.component';
import { RelatedRow } from './related-row/related-row.component';
import { List, Accordion, ItemList, LazyItemList, RowSelectList, DateSelectList } from './list/';
import { Tags } from './tags/tags.component';
import { EventItem, EventList } from './events/';
import { AppFooter } from './footer/app-footer.component';
import { EmailField } from './email-field/email-field.component';
import { MarqueeDocument } from './marquee-document/marquee-document.component';
import { FeatureList, FeatureItem } from './feature-list/';
import { VideoPlayer } from './video-player/video-player.component';
import { MicroVideoPlayer } from './video-player/micro-video-player.component';
import { VgFlashMedia } from './video-player/flash-hls-fallback/vg-flash.media/vg-flash.media.component';
import { VgOverlayPoster, VgSocialLinks, VgSnipe, VgUpNext, VgShare, VgScrubBarThumbnailOverlay, VgTimedPopups } from './video-player/controls';
import { VgLike } from './video-player/controls/vg-like/vg-like.component';
import { VgFavorite } from './video-player/controls/vg-favorite/vg-favorite.component';
import { VgTheatreMode } from './video-player/controls/vg-theatre-mode/vg-theatre-mode.component';
import { ContentList } from './content-list/content-list.component';
import { TextPost } from './text-post/text-post.component';
import { StreamRow } from './stream-row/stream-row.component';
import { CarouselRow } from './carousel-row/carousel-row.component';
import { SeriesList, SeasonList, EpisodeCarousel, SeriesSpotlight, DetailView, VdgmSelect, VdgmDatePicker } from './series';
import { PlaylistRow } from './video-playlist';
import { LogoRow } from './logo-row/logo-row.component';
import { Search, SearchSection } from './search/';
import { ListMarquee } from './list-marquee/list-marquee.component';
import { ContactUs } from './contact-us/contact-us.component';
import { VideoEmbedShare } from './video-embed/video-embed-share.component';
import { TabList } from './tab-list/tab-list.component';
import { VgSocialIcons } from './video-player/controls/vg-social-icons.component';
import { VgChromecastMedia } from './video-player/vg-chromecast/vg-chromecast.media/vg-chromecast.media.component';
import { CastWidget } from './chromcast-widget/cast-widget.component';
import { VdgmSwiper } from './vdgm-swiper/vdgm-swiper.component';
import { AdComponent } from './ad/ad.component';
import { SpotlightComponent } from './spotlight/spotlight.component';
import { MobileSpotlightComponent } from './spotlight/mobile-spotlight/mobile-spotlight.component';
import { PeopleList } from './people-list/people-list.component';
import { TwoColumnView, ColumnView } from './column-layout'
import { MatDatepickerModule } from '@angular/material';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MomentModule } from 'ngx-moment';
import { UserPlaylist } from './user-playlist/user-playlist.component';
import { UserDevices } from './user-devices/user-devices.component';
import { Tab, TabsView } from './tabs'
import { YoutubePlayer } from './youtube-player/youtube-player.component';

@NgModule({
    imports: [
        CommonModule,
        BrowserModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        ImagesModule,
        SharedComponentsModule,
        SharedPipesModule,
        SharedDirectivesModule,
        VgCoreModule,
        VgControlsModule,
        VgOverlayPlayModule,
        VgBufferingModule,
        VgStreamingModule,
        //SwiperModule,
        ClipboardModule,
        MatDatepickerModule,
        MatMomentDateModule,
        MomentModule
    ],
    declarations: [
        VideoPlayer,
        MicroVideoPlayer,
        VgFlashMedia,
        VgChromecastMedia,
        CastWidget,
        VgOverlayPoster,
        VgSocialLinks,
        VgSocialIcons,
        VgSnipe,
        VgUpNext,
        VgShare,
        VgScrubBarThumbnailOverlay,
        Rows,
        PageTitle,
        Row,
        TitleRow,
        ImageItem,
        NavBar,
        NavPoint,
        NavMenu,
        MediaCell,
        RowContainer,
        MobileRowContainer,
        MobileContentNavigation,
        MediaDetail,
        VideoDetail,
        RowHeader,
        SeasonHeader,
        MarqueeCell,
        MarqueeRow,
        MarqueeDocument,
        SplitMarquee,
        FullMarquee,
        VideoRow,
        GalleryRow,
        CopyRow,
        Copy,
        ContentRow,
        ContentBuilder,
        SocialIcons,
        DetailRow,
        RelatedRow,
        GalleryCell,
        EventItem,
        EventList,
        AppFooter,
        Tags,
        EmailField,
        List,
        Accordion,
        FeatureList,
        FeatureItem,
        ContentList,
        TextPost,
        StreamRow,
        CarouselRow,
        SeriesList,
        SeasonList,
        PlaylistRow,
        LogoRow,
        MarqueeList,
        MediaHeadliner,
        EpisodeCarousel,
        Search,
        SearchSection,
        CategoryFilter,
        ListMarquee,
        ContactUs,
        VideoEmbedShare,
    VgTimedPopups,
        VdgmSwiper,
        PercentPlayed,
        AdComponent,
        VgLike,
        VgFavorite,
        VgTheatreMode,
        SpotlightComponent,
        MobileSpotlightComponent,
        PeopleList,
        UserProfile,
        SeriesSpotlight,
        DetailView,
        ItemList,
        LazyItemList,
        RowSelectList,
        DateSelectList,
        VdgmSelect,
        VdgmDatePicker,
        TwoColumnView,
        ColumnView,
        UserPlaylist,
        TabList,
        UserDevices,
        Tab, TabsView,
        YoutubePlayer,
],
    exports: [
        VideoPlayer,
        MicroVideoPlayer,
        VgFlashMedia,
        VgChromecastMedia,
        CastWidget,
        VgOverlayPoster,
        VgSocialLinks,
        VgSocialIcons,
        VgSnipe,
        VgUpNext,
        VgShare,
        VgScrubBarThumbnailOverlay,
        Rows,
        PageTitle,
        Row,
        TitleRow,
        ImageItem,
        NavBar,
        NavPoint,
        NavMenu,
        MediaCell,
        RowContainer,
        MobileRowContainer,
        MobileContentNavigation,
        MediaDetail,
        VideoDetail,
        RowHeader,
        SeasonHeader,
        MarqueeCell,
        MarqueeRow,
        MarqueeDocument,
        SplitMarquee,
        FullMarquee,
        VideoRow,
        GalleryRow,
        CopyRow,
        Copy,
        ContentRow,
        ContentBuilder,
        SocialIcons,
        DetailRow,
        RelatedRow,
        GalleryCell,
        EventItem,
        EventList,
        AppFooter,
        Tags,
        EmailField,
        List,
        Accordion,
        FeatureList,
        FeatureItem,
        ContentList,
        TextPost,
        StreamRow,
        CarouselRow,
        SeriesList,
        SeasonList,
        MarqueeList,
        PlaylistRow,
        MediaHeadliner,
        LogoRow,
        EpisodeCarousel,
        Search,
        SearchSection,
        CategoryFilter,
        ListMarquee,
        ContactUs,
        VideoEmbedShare,
    VgTimedPopups,
        VdgmSwiper,
        PercentPlayed,
        AdComponent,
        VgLike,
        VgFavorite,
        VgTheatreMode,
        SpotlightComponent,
        MobileSpotlightComponent,
        PeopleList,
        UserProfile,
        SeriesSpotlight,
        DetailView,
        ItemList,
        LazyItemList,
        RowSelectList,
        DateSelectList,
        VdgmSelect,
        VdgmDatePicker,
        TwoColumnView,
        ColumnView,
        UserPlaylist,
        TabList,
        UserDevices,
        Tab, TabsView,
        YoutubePlayer,
    ],
    providers: [
    ]
})
export class PresentationalComponentsModule {

}



// WEBPACK FOOTER //
// ./src/angular-framework-client-components/components/components.module.ts